import { render, staticRenderFns } from "./CaseFields.vue?vue&type=template&id=75326944&scoped=true&"
import script from "./CaseFields.vue?vue&type=script&lang=ts&"
export * from "./CaseFields.vue?vue&type=script&lang=ts&"
import style0 from "./CaseFields.vue?vue&type=style&index=0&id=75326944&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75326944",
  null
  
)

export default component.exports